module.exports = __webpack_public_path__ + "img/Urne_et_livre_d_or.95683f4.jpg";